const timers = new Map();

function startTimer(id, duration) {
    const timeoutId = setTimeout(() => Alpine.store('toasts').remove(id), duration);
    timers.set(id, {
        timeoutId,
        expiresAt: Date.now() + duration,
        remaining: null, // null means the timer is running and not paused
    });
}

document.addEventListener('alpine:init', () => {
    Alpine.store('toasts', {
        items: [],
        counter: 0,

        /**
         * @param {string} message
         * @param {Object} options
         * @param {'success'|'error'|'info'|'warning'} options.type
         * @param {number} options.duration - Duration in milliseconds (default: 4000). Set to 0 for persistent toast.
         */
        add(message, { type = 'info', duration = 4000 } = {}) {
            const id = ++this.counter;
            this.items.unshift({ id, message, type });

            if (duration > 0) {
                startTimer(id, duration);
            }

            return id;
        },

        remove(id) {
            const timer = timers.get(id);
            if (timer) {
                clearTimeout(timer.timeoutId);
                timers.delete(id);
            }

            this.items = this.items.filter(toast => toast.id !== id);
        },

        pauseAll() {
            for (const timer of timers.values()) {
                if (timer.remaining !== null) continue;
                clearTimeout(timer.timeoutId);
                timer.remaining = timer.expiresAt - Date.now();
            }
        },

        resumeAll() {
            for (const [id, timer] of timers.entries()) {
                if (timer.remaining === null) continue;
                // Small grace period, so toast doesn't disappear immediately after resuming
                startTimer(id, Math.max(timer.remaining, 800));
            }
        },
    });
});

// Shortcut used by any component that wants to trigger a toast (e.g. window.vacancyAlertsComponent).
window.addToast = (message, options) => Alpine.store('toasts').add(message, options);

// Renders and stacks/fans out the toasts. See resources/assets/js/shared/components/jobsite/toasts/ToastMessages.vue.
window.toastMessages = function () {
    return {
        isFanned: false,
        supportsHover: typeof window !== 'undefined' && window.matchMedia('(hover: hover)').matches,

        typeConfig: {
            success: {
                accent: 'border-l-semantic-success',
                iconColor: 'text-semantic-success',
                iconPath: 'M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
            },
            error: {
                accent: 'border-l-semantic-error',
                iconColor: 'text-semantic-error',
                iconPath: 'M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
            },
            info: {
                accent: 'border-l-semantic-info',
                iconColor: 'text-semantic-info',
                iconPath: 'M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z',
            },
            warning: {
                accent: 'border-l-semantic-warning',
                iconColor: 'text-semantic-warning',
                iconPath: 'M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z',
            },
        },

        init() {
            this.$watch('isFanned', (fanned) => fanned ? this.pauseAll() : this.resumeAll());
            this.$watch('$store.toasts.items.length', (length) => {
                if (length <= 1) this.isFanned = false;
            });
        },

        onStackClickCapture(event) {
            if (!this.supportsHover && !this.isFanned && this.$store.toasts.items.length > 1) {
                event.stopPropagation();
                this.isFanned = true;
            }
        },

        onTouchEnd() {
            if (!this.isFanned) {
                this.resumeAll();
            }
        },

        pauseAll() {
            Alpine.store('toasts').pauseAll();
        },

        resumeAll() {
            Alpine.store('toasts').resumeAll();
        },

        remove(id) {
            Alpine.store('toasts').remove(id);
        },

        stackStyle(index) {
            if (this.isFanned) {
                return {
                    transform: 'scale(1)',
                    marginTop: index === 0 ? '0' : '0.5rem',
                };
            }

            return {
                transform: `scale(${1 - index * 0.05})`,
                marginTop: index === 0 ? '0' : '-1.5rem',
            };
        },
    };
};
